export default "__VITE_ASSET__BnoGsD3z__"